import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {
  GoogleChatSpacesResponseDto,
  GoogleChatProjectStatusResponseDto,
  GoogleChatProjectSpaceResponseDto,
  GoogleChatProjectSpaceRequestDto,
  GoogleChatNotificationSettingsDto,
  GoogleChatMessageResponseDto,
  GoogleChatOrgStatusResponseDto,
  GoogleChatActivateResponseDto,
} from '../models/google-chat.dto';

@Injectable({
  providedIn: 'root'
})
export class GoogleChatService {
  private readonly apiUrl = `${environment.apiHost}/api`;

  constructor(private readonly http: HttpClient) {}

  public listSpaces(): Observable<GoogleChatSpacesResponseDto> {
    return this.http.get<GoogleChatSpacesResponseDto>(
      `${this.apiUrl}/google-chat/spaces/`
    );
  }

  public getProjectStatus(projectId: string): Observable<GoogleChatProjectStatusResponseDto> {
    return this.http.get<GoogleChatProjectStatusResponseDto>(
      `${this.apiUrl}/google-chat/projects/${projectId}/status/`
    );
  }

  public getProjectSpace(projectId: string): Observable<GoogleChatProjectSpaceResponseDto> {
    return this.http.get<GoogleChatProjectSpaceResponseDto>(
      `${this.apiUrl}/google-chat/projects/${projectId}/space/`
    );
  }

  public setProjectSpace(
    projectId: string,
    data: GoogleChatProjectSpaceRequestDto
  ): Observable<GoogleChatProjectSpaceResponseDto> {
    return this.http.post<GoogleChatProjectSpaceResponseDto>(
      `${this.apiUrl}/google-chat/projects/${projectId}/space/`,
      data
    );
  }

  public removeProjectSpace(projectId: string): Observable<GoogleChatMessageResponseDto> {
    return this.http.delete<GoogleChatMessageResponseDto>(
      `${this.apiUrl}/google-chat/projects/${projectId}/space/`
    );
  }

  public updateNotifications(
    projectId: string,
    data: GoogleChatNotificationSettingsDto
  ): Observable<GoogleChatProjectSpaceResponseDto> {
    return this.http.patch<GoogleChatProjectSpaceResponseDto>(
      `${this.apiUrl}/google-chat/projects/${projectId}/notifications/`,
      data
    );
  }

  public testNotification(projectId: string): Observable<GoogleChatMessageResponseDto> {
    return this.http.post<GoogleChatMessageResponseDto>(
      `${this.apiUrl}/google-chat/projects/${projectId}/test/`,
      {}
    );
  }

  // ─── Organization-level ──────────────────────────────────

  public getOrgStatus(orgId: string): Observable<GoogleChatOrgStatusResponseDto> {
    return this.http.get<GoogleChatOrgStatusResponseDto>(
      `${this.apiUrl}/google-chat/orgs/${orgId}/status/`
    );
  }

  public activateOrg(orgId: string, privateKey: string): Observable<GoogleChatActivateResponseDto> {
    return this.http.post<GoogleChatActivateResponseDto>(
      `${this.apiUrl}/google-chat/orgs/${orgId}/activate/`,
      { private_key: privateKey }
    );
  }

  public deactivateOrg(orgId: string): Observable<GoogleChatMessageResponseDto> {
    return this.http.delete<GoogleChatMessageResponseDto>(
      `${this.apiUrl}/google-chat/orgs/${orgId}/activate/`
    );
  }
}
